import React, { useState } from "react"
import Svg from "../_svgs/svg"
import { CookiesProvider } from "react-cookie"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import LoginState from "../../booking/components/loginState"
import LanguageSelector from "./language-selector"
import UniverseSelectionBar from "./universe-selection-bar"

export default function HeaderMobile({
  isMobileMenuActive,
  logo,
  logoOverride,
  logoLink,
  logoTracking,
  handleMobileSearchOpen,
  handleMobileMenuToggle,
  languages,
  useParkingLanguageSelection,
  loginState,
  headerLinks,
  handleClickTracking,
  shopLogoTracking,
  shopLogoLink,
  shopLogo,
  megaMenuCard,
  shopLogoLinkTarget,
  languageChoiceLabel,
  sectionNotAvailableText,
  pageNotAvailableText,
  universeSelection,
  universesSelectText,
}) {
  return (
    <div className={`main-navigation--mobile js--mobile-navigation ${isMobileMenuActive ? "is-active is-fixed" : ""}`}>
      <div className="main-navigation--mobile__top">
        <a
          className={`button button--nav button--logo ${logoOverride && "button--logo--override"}`}
          href={logoLink}
          onClick={() => handleClickTracking(logoTracking)}
        >
          {logoOverride ? <img src={logoOverride} alt="Logo" /> : <Svg iconName={logo || "logo-tight"} />}
        </a>
        <div className="main-navigation__item main-navigation__item--search" onClick={() => handleMobileSearchOpen()}>
          <a className="button button--nav button--nav--search">
            <Svg iconClass={"icon"} iconName={"search-new"} />
          </a>
        </div>
        <button className="button button--toggle js--navigation-toggle" onClick={() => handleMobileMenuToggle()}>
          <Svg iconClass={"icon"} iconName={"burgermenu"} />
        </button>
      </div>
      <ul className={`main-navigation--mobile__list js--navigation-inner ${isMobileMenuActive ? "is-active" : ""}`}>
        <li>
          <div className="main-navigation--mobile__list__top">
            <LanguageSelector
              languageChoiceLabel={languageChoiceLabel}
              languages={languages}
              useParkingLanguageSelection={useParkingLanguageSelection}
            />

            <div className={`main-navigation__item main-navigation__item--user`}>
              <CookiesProvider>
                <LoginState config={loginState} />
              </CookiesProvider>
            </div>
            <button className="button button--toggle js--navigation-toggle" onClick={() => handleMobileMenuToggle()}>
              <Svg iconClass={"icon2"} iconName={"close-new"} />
            </button>
          </div>
        </li>
        {headerLinks && headerLinks.length > 0
          ? headerLinks.map((item, index) => {
              return (
                <MobileLinkList
                  key={"mobileLinkList" + index}
                  megaMenuCard={megaMenuCard}
                  link={item.link}
                  linkText={item.linkText}
                  handleClickTracking={handleClickTracking}
                  sectionNotAvailableText={sectionNotAvailableText}
                  pageNotAvailableText={pageNotAvailableText}
                  isMobileMenuActive={isMobileMenuActive}
                  {...item}
                />
              )
            })
          : ""}
        {shopLogo && shopLogoLink ? (
          <li className="taxfreelink">
            <a href={shopLogoLink} onClick={() => handleClickTracking(shopLogoTracking)} target={shopLogoLinkTarget}>
              <img src={shopLogo} alt="" />
            </a>
          </li>
        ) : (
          ""
        )}
        <li>
          <UniverseSelectionBar universeSelection={universeSelection} universesSelectText={universesSelectText} isMobile={true} />
        </li>
      </ul>
    </div>
  )
}

function MobileLinkList({ megaMenuCard, link, linkText, handleClickTracking, sectionNotAvailableText, pageNotAvailableText, isMobileMenuActive }) {
  const [isToggle, setIsToggle] = useState(false)

  //TODO - Do this with React
  const showHideContent = (event, classname) => {
    setIsToggle(!isToggle)
    let elem = event.currentTarget
    elem.__toggle = !elem.__toggle
    let target = elem.parentElement.querySelector(classname)
    if (elem.__toggle) {
      target.style.height = target.scrollHeight + "px"
      elem.classList.add("is-active")
    } else {
      target.style.height = 0 + "px"
      elem.classList.remove("is-active")
    }
  }

  const getLinkList = (linkArea, megaMenuElements) => {
    let linkList = []
    if (linkArea) {
      linkList = linkList.concat(linkArea)
    }

    if (megaMenuElements) {
      megaMenuElements.forEach((elem) => {
        if (elem.__type__ === "MegaMenuLinkListElement") {
          const firstLink = elem.firstLink
          firstLink.isFirstLink = true
          linkList.push(firstLink)
          linkList = linkList.concat(elem.linkArea)
        } else {
          linkList.push(elem.linkItem)
        }
      })
    }

    return linkList
  }

  let linkList = []
  if (megaMenuCard) linkList = getLinkList(megaMenuCard.linkArea, megaMenuCard.megaMenuElements)

  const showAnnotation = megaMenuCard.annotate || (!megaMenuCard.annotate && megaMenuCard.hasAnnotatedLinks)
  return (
    <li>
      <div className="mobile-navigation__links">
        <div className="topmenuitem button button--link has-icon" onClick={(e) => showHideContent(e, ".contentWrapper")}>
          <a className="text" href={link} tabIndex={isMobileMenuActive ? 0 : -1}>
            {linkText}
          </a>
        </div>
        <div className={"contentWrapper show-hide"}>
          {showAnnotation ? (
            <div className={`annotation-text`}>
              {megaMenuCard.annotate ? <p>{sectionNotAvailableText.replace("*", "").replace("{headline}", linkText)}</p> : ""}
              {!megaMenuCard.annotate && megaMenuCard.hasAnnotatedLinks ? <p>{pageNotAvailableText}</p> : ""}
            </div>
          ) : (
            ""
          )}
          <ul className={"links-list"}>
            {linkList && linkList.length > 0
              ? linkList.map((link, index) => {
                  const linkTarget = SelectionFactoryHelper.getFromSelectionFactory(link.linkTarget)
                  return (
                    <li key={index} className="links-list__item">
                      <a
                        tabIndex={isToggle ? 0 : -1}
                        className={`button button--link has-icon ${link.isFirstLink ? "first-link" : ""}`}
                        target={linkTarget}
                        href={link.linkUrl}
                        onClick={() => handleClickTracking(link.linkTracking)}
                      >
                        <span className="text">{`${link.linkText}${!megaMenuCard.annotate && link.annotate ? "*" : ""}`}</span>
                      </a>
                    </li>
                  )
                })
              : ""}
          </ul>
        </div>
      </div>
    </li>
  )
}
